import React from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

interface CreateRepositoryDialogProps {
  open: boolean;
  repositoryName: string;
  createError: string | null;
  isLoading: boolean;
  isValidating: boolean;
  repositoryNameExists: boolean;
  onClose: () => void;
  onRepositoryNameChange: (name: string) => void;
  onCreateRepository: () => Promise<void>;
}

const getValidationHelperText = (
  isValidating: boolean,
  repositoryNameExists: boolean,
): string => {
  if (isValidating) return 'Validating...';
  if (repositoryNameExists) return 'A repository with this name already exists';
  return '';
};

const CreateRepositoryDialog: React.FC<CreateRepositoryDialogProps> = ({
  open,
  repositoryName,
  createError,
  isLoading,
  isValidating,
  repositoryNameExists,
  onClose,
  onRepositoryNameChange,
  onCreateRepository,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Repository</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Repository Name"
          fullWidth
          variant="outlined"
          value={repositoryName}
          onChange={(e) => onRepositoryNameChange(e.target.value)}
          error={!!createError || repositoryNameExists}
          helperText={
            createError || getValidationHelperText(isValidating, repositoryNameExists)
          }
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={onCreateRepository}
          variant="contained"
          disabled={
            isLoading || isValidating || !repositoryName.trim() || repositoryNameExists || !!createError
          }
        >
          {isLoading ? 'Creating...' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateRepositoryDialog;
